import type { AdminReviewRow } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { formatDateTime } from '@/shared/lib';
import { cn, StatusBadge, tableStyles } from '@/shared/ui';

interface ReviewListRowProps {
  readonly review: AdminReviewRow;
}

/** 후기 목록의 한 행 — 내용 앞부분을 누르면 상세(/reviews/:id)로 간다. */
export const ReviewListRow = ({ review }: ReviewListRowProps): ReactElement => (
  <tr className={tableStyles.row}>
    <td className={tableStyles.td}>{review.productName}</td>
    <td className={cn(tableStyles.td, 'whitespace-nowrap tabular-nums')}>{review.rating}점</td>
    <td className={cn(tableStyles.td, 'min-w-56')}>
      <Link
        to={`/reviews/${review.id}`}
        className="underline decoration-foreground/30 underline-offset-4 hover:decoration-foreground focus-visible:outline-none"
      >
        {review.contentPreview}
      </Link>
    </td>
    <td className={cn(tableStyles.td, 'tabular-nums')}>{review.imageCount}</td>
    <td className={cn(tableStyles.td, 'whitespace-nowrap')}>{review.authorName}</td>
    <td className={tableStyles.td}>
      <StatusBadge tone={review.status === 'HIDDEN' ? 'danger' : 'positive'}>
        {review.status === 'HIDDEN' ? '숨김' : '공개'}
      </StatusBadge>
    </td>
    <td className={cn(tableStyles.td, 'whitespace-nowrap')}>{formatDateTime(review.createdAt)}</td>
  </tr>
);
